/** Minimum trimmed query length before calling Google Places Autocomplete. */
export const PLACES_AUTOCOMPLETE_MIN_CHARS = 4;

/** Debounce delay for location suggestion queries (SearchBar, LocationSearchInput). */
export const PLACES_AUTOCOMPLETE_DEBOUNCE_MS = 800;

export function shouldFetchPlacesAutocomplete(
  isInputFocused: boolean,
  hasEditedSinceFocus: boolean,
): boolean {
  return isInputFocused && hasEditedSinceFocus;
}
